import { render, staticRenderFns } from "./jumpEzSort.vue?vue&type=template&id=513b485c&scoped=true&"
import script from "./jumpEzSort.vue?vue&type=script&lang=ts&setup=true&"
export * from "./jumpEzSort.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./jumpEzSort.vue?vue&type=style&index=0&id=513b485c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b485c",
  null
  
)

export default component.exports